import type { FirebaseOptions } from 'firebase/app'

// Player app Firebase projects (SEPARATE from clubmanager's club-* projects —
// players are a different auth pool; blast-radius + billing isolation). Web API
// keys below are public client config (not secrets), embedded per the same
// pattern as clubmanager's core/firebase/config.ts.
const dev: FirebaseOptions = {
  apiKey: 'AIzaSyAg1QmeAgkuf4HFfRkVog4CSU-cUrK_j4o',
  appId: '1:305302551406:web:fd2c4824a460b2cf175f7f',
  messagingSenderId: '305302551406',
  measurementId: 'G-0H6E0BNXRJ',
  projectId: 'upadelmatch-usersmatch-dev',
  authDomain: 'upadelmatch-usersmatch-dev.firebaseapp.com',
  storageBucket: 'upadelmatch-usersmatch-dev.firebasestorage.app',
}

const prod: FirebaseOptions = {
  apiKey: 'AIzaSyDtfyiKa5SRBUIYwuTfxcfbGXMqabPAvDI',
  appId: '1:26754318351:web:9c96ae269b08301f78a37a',
  messagingSenderId: '26754318351',
  measurementId: 'G-8VJVCEVN65',
  projectId: 'upadelmatch-usersmatch-prod',
  authDomain: 'upadelmatch-usersmatch-prod.firebaseapp.com',
  storageBucket: 'upadelmatch-usersmatch-prod.firebasestorage.app',
}

export type Env = 'dev' | 'prod'

// `VITE_ENV` is injected at build time from vite.config.ts (derived from Vite
// mode). Mirrors clubmanager's post-incident rule: no hostname sniffing — the
// build target is deterministic so dev hosting can never load the prod project.
function resolveEnv(): Env {
  const fromVite = import.meta.env['VITE_ENV']
  if (fromVite === 'prod' || fromVite === 'dev') return fromVite
  if (import.meta.env.PROD) {
    throw new Error('VITE_ENV missing on production build — set it in vite.config.ts define.')
  }
  return 'dev'
}

export const env: Env = resolveEnv()

export const firebaseConfig: FirebaseOptions = env === 'prod' ? prod : dev
